// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3Comj","right":"styles_right__guomE"};